

export default function QrImage(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="138"
            height="133"
            viewBox="0 0 138 133"
            fill="none"
            {...props}
        >
            <path d="M5.52 0H0V5.32H5.52V0Z" fill="black"/>
            <path d="M11.04 0H5.52V5.32H11.04V0Z" fill="black"/>
            <path d="M16.56 0H11.04V5.32H16.56V0Z" fill="black"/>
            <path d="M22.08 0H16.56V5.32H22.08V0Z" fill="black"/>
            <path d="M27.6 0H22.08V5.32H27.6V0Z" fill="black"/>
            <path d="M33.12 0H27.6V5.32H33.12V0Z" fill="black"/>
            <path d="M38.64 0H33.12V5.32H38.64V0Z" fill="black"/>
            <path d="M49.68 0H44.16V5.32H49.68V0Z" fill="black"/>
            <path d="M55.2 0H49.68V5.32H55.2V0Z" fill="black"/>
            <path d="M60.72 0H55.2V5.32H60.72V0Z" fill="black"/>
            <path d="M66.24 0H60.72V5.32H66.24V0Z" fill="black"/>
            <path d="M82.8 0H77.28V5.32H82.8V0Z" fill="black"/>
            <path d="M93.84 0H88.32V5.32H93.84V0Z" fill="black"/>
            <path d="M104.88 0H99.36V5.32H104.88V0Z" fill="black"/>
            <path d="M110.4 0H104.88V5.32H110.4V0Z" fill="black"/>
            <path d="M115.92 0H110.4V5.32H115.92V0Z" fill="black"/>
            <path d="M121.44 0H115.92V5.32H121.44V0Z" fill="black"/>
            <path d="M126.96 0H121.44V5.32H126.96V0Z" fill="black"/>
            <path d="M132.48 0H126.96V5.32H132.48V0Z" fill="black"/>
            <path d="M138 0H132.48V5.32H138V0Z" fill="black"/>
            <path d="M5.52 5.32H0V10.64H5.52V5.32Z" fill="black"/>
            <path d="M38.64 5.32H33.12L33.12 10.64H38.64V5.32Z" fill="black"/>
            <path d="M60.72 5.32H55.2V10.64H60.72V5.32Z" fill="black"/>
            <path d="M66.24 5.32H60.72V10.64H66.24V5.32Z" fill="black"/>
            <path d="M71.76 5.32H66.24V10.64H71.76V5.32Z" fill="black"/>
            <path d="M82.8 5.32H77.28V10.64H82.8V5.32Z" fill="black"/>
            <path d="M93.84 5.32H88.32V10.64H93.84V5.32Z" fill="black"/>
            <path d="M104.88 5.32H99.36V10.64H104.88V5.32Z" fill="black"/>
            <path d="M138 5.32H132.48V10.64H138V5.32Z" fill="black"/>
            <path d="M5.52 10.64H0V15.96H5.52V10.64Z" fill="black"/>
            <path d="M16.56 10.64H11.04V15.96H16.56V10.64Z" fill="black"/>
            <path d="M22.08 10.64H16.56V15.96H22.08V10.64Z" fill="black"/>
            <path d="M27.6 10.64H22.08V15.96H27.6V10.64Z" fill="black"/>
            <path d="M38.64 10.64H33.12V15.96H38.64V10.64Z" fill="black"/>
            <path d="M49.68 10.64H44.16V15.96H49.68V10.64Z" fill="black"/>
            <path d="M55.2 10.64H49.68V15.96H55.2V10.64Z" fill="black"/>
            <path d="M60.72 10.64H55.2V15.96H60.72V10.64Z" fill="black"/>
            <path d="M93.84 10.64H88.32V15.96H93.84V10.64Z" fill="black"/>
            <path d="M104.88 10.64H99.36V15.96H104.88V10.64Z" fill="black"/>
            <path d="M115.92 10.64H110.4V15.96H115.92V10.64Z" fill="black"/>
            <path d="M121.44 10.64H115.92V15.96H121.44V10.64Z" fill="black"/>
            <path d="M126.96 10.64H121.44V15.96H126.96V10.64Z" fill="black"/>
            <path d="M138 10.64H132.48V15.96H138V10.64Z" fill="black"/>
            <path d="M5.52 15.96H0V21.28H5.52V15.96Z" fill="black"/>
            <path d="M16.56 15.96H11.04V21.28H16.56V15.96Z" fill="black"/>
            <path d="M22.08 15.96H16.56V21.28H22.08V15.96Z" fill="black"/>
            <path d="M27.6 15.96H22.08V21.28H27.6V15.96Z" fill="black"/>
            <path d="M38.64 15.96H33.12V21.28H38.64V15.96Z" fill="black"/>
            <path d="M55.2 15.96H49.68V21.28H55.2V15.96Z" fill="black"/>
            <path d="M66.24 15.96H60.72V21.28H66.24V15.96Z" fill="black"/>
            <path d="M77.28 15.96H71.76V21.28H77.28V15.96Z" fill="black"/>
            <path d="M82.8 15.96H77.28V21.28H82.8V15.96Z" fill="black"/>
            <path d="M104.88 15.96H99.36V21.28H104.88V15.96Z" fill="black"/>
            <path d="M115.92 15.96H110.4V21.28H115.92V15.96Z" fill="black"/>
            <path d="M121.44 15.96H115.92V21.28H121.44V15.96Z" fill="black"/>
            <path d="M126.96 15.96H121.44V21.28H126.96V15.96Z" fill="black"/>
            <path d="M138 15.96H132.48V21.28H138V15.96Z" fill="black"/>
            <path d="M5.52 21.28H0V26.6H5.52V21.28Z" fill="black"/>
            <path d="M16.56 21.28H11.04V26.6H16.56V21.28Z" fill="black"/>
            <path d="M22.08 21.28H16.56V26.6H22.08V21.28Z" fill="black"/>
            <path d="M27.6 21.28H22.08V26.6H27.6V21.28Z" fill="black"/>
            <path d="M38.64 21.28H33.12V26.6H38.64V21.28Z" fill="black"/>
            <path d="M55.2 21.28H49.68V26.6H55.2V21.28Z" fill="black"/>
            <path d="M60.72 21.28H55.2V26.6H60.72V21.28Z" fill="black"/>
            <path d="M71.76 21.28H66.24V26.6H71.76V21.28Z" fill="black"/>
            <path d="M88.32 21.28H82.8L82.8 26.6H88.32V21.28Z" fill="black"/>
            <path d="M93.84 21.28H88.32V26.6H93.84V21.28Z" fill="black"/>
            <path d="M104.88 21.28H99.36V26.6H104.88V21.28Z" fill="black"/>
            <path d="M115.92 21.28H110.4V26.6H115.92V21.28Z" fill="black"/>
            <path d="M121.44 21.28H115.92V26.6H121.44V21.28Z" fill="black"/>
            <path d="M126.96 21.28H121.44V26.6H126.96V21.28Z" fill="black"/>
            <path d="M138 21.28H132.48V26.6H138V21.28Z" fill="black"/>
            <path d="M5.52 26.6H0V31.92H5.52V26.6Z" fill="black"/>
            <path d="M38.64 26.6H33.12V31.92H38.64V26.6Z" fill="black"/>
            <path d="M55.2 26.6H49.68V31.92H55.2V26.6Z" fill="black"/>
            <path d="M77.28 26.6H71.76V31.92H77.28V26.6Z" fill="black"/>
            <path d="M88.32 26.6H82.8V31.92H88.32V26.6Z" fill="black"/>
            <path d="M104.88 26.6H99.36V31.92H104.88V26.6Z" fill="black"/>
            <path d="M138 26.6H132.48V31.92H138V26.6Z" fill="black"/>
            <path d="M5.52 31.92H0V37.24H5.52V31.92Z" fill="black"/>
            <path d="M11.04 31.92L5.52 31.92V37.24H11.04V31.92Z" fill="black"/>
            <path d="M16.56 31.92H11.04V37.24H16.56V31.92Z" fill="black"/>
            <path d="M22.08 31.92H16.56V37.24H22.08V31.92Z" fill="black"/>
            <path d="M27.6 31.92H22.08V37.24H27.6V31.92Z" fill="black"/>
            <path d="M33.12 31.92L27.6 31.92V37.24H33.12L33.12 31.92Z" fill="black"/>
            <path d="M38.64 31.92H33.12L33.12 37.24H38.64V31.92Z" fill="black"/>
            <path d="M49.68 31.92L44.16 31.92V37.24H49.68V31.92Z" fill="black"/>
            <path d="M60.72 31.92L55.2 31.92V37.24H60.72V31.92Z" fill="black"/>
            <path d="M71.76 31.92L66.24 31.92V37.24H71.76V31.92Z" fill="black"/>
            <path d="M82.8 31.92H77.28V37.24H82.8L82.8 31.92Z" fill="black"/>
            <path d="M93.84 31.92L88.32 31.92V37.24H93.84V31.92Z" fill="black"/>
            <path d="M104.88 31.92H99.36V37.24H104.88V31.92Z" fill="black"/>
            <path d="M110.4 31.92L104.88 31.92V37.24H110.4V31.92Z" fill="black"/>
            <path d="M115.92 31.92H110.4V37.24H115.92V31.92Z" fill="black"/>
            <path d="M121.44 31.92H115.92V37.24H121.44V31.92Z" fill="black"/>
            <path d="M126.96 31.92H121.44V37.24H126.96V31.92Z" fill="black"/>
            <path d="M132.48 31.92L126.96 31.92V37.24H132.48V31.92Z" fill="black"/>
            <path d="M138 31.92H132.48V37.24H138V31.92Z" fill="black"/>
            <path d="M49.68 37.24H44.16V42.56H49.68V37.24Z" fill="black"/>
            <path d="M55.2 37.24H49.68V42.56H55.2V37.24Z" fill="black"/>
            <path d="M60.72 37.24H55.2V42.56H60.72V37.24Z" fill="black"/>
            <path d="M66.24 37.24H60.72V42.56H66.24V37.24Z" fill="black"/>
            <path d="M77.28 37.24H71.76V42.56H77.28V37.24Z" fill="black"/>
            <path d="M82.8 37.24H77.28V42.56H82.8V37.24Z" fill="black"/>
            <path d="M88.32 37.24H82.8V42.56H88.32V37.24Z" fill="black"/>
            <path d="M93.84 37.24H88.32V42.56H93.84V37.24Z" fill="black"/>
            <path d="M5.52 42.56H0V47.88H5.52V42.56Z" fill="black"/>
            <path d="M16.56 42.56H11.04V47.88H16.56V42.56Z" fill="black"/>
            <path d="M33.12 42.56H27.6V47.88H33.12V42.56Z" fill="black"/>
            <path d="M38.64 42.56H33.12V47.88H38.64V42.56Z" fill="black"/>
            <path d="M77.28 42.56H71.76V47.88H77.28V42.56Z" fill="black"/>
            <path d="M88.32 42.56H82.8L82.8 47.88H88.32V42.56Z" fill="black"/>
            <path d="M93.84 42.56H88.32V47.88H93.84V42.56Z" fill="black"/>
            <path d="M99.36 42.56H93.84V47.88H99.36V42.56Z" fill="black"/>
            <path d="M104.88 42.56H99.36V47.88H104.88V42.56Z" fill="black"/>
            <path d="M126.96 42.56H121.44V47.88H126.96V42.56Z" fill="black"/>
            <path d="M138 42.56H132.48V47.88H138V42.56Z" fill="black"/>
            <path d="M33.12 47.88H27.6V53.2H33.12V47.88Z" fill="black"/>
            <path d="M66.24 47.88H60.72V53.2H66.24V47.88Z" fill="black"/>
            <path d="M71.76 47.88H66.24V53.2H71.76V47.88Z" fill="black"/>
            <path d="M82.8 47.88H77.28V53.2H82.8L82.8 47.88Z" fill="black"/>
            <path d="M93.84 47.88H88.32V53.2H93.84V47.88Z" fill="black"/>
            <path d="M104.88 47.88H99.36V53.2H104.88V47.88Z" fill="black"/>
            <path d="M121.44 47.88H115.92V53.2H121.44V47.88Z" fill="black"/>
            <path d="M132.48 47.88H126.96V53.2H132.48V47.88Z" fill="black"/>
            <path d="M138 47.88H132.48V53.2H138V47.88Z" fill="black"/>
            <path d="M11.04 53.2H5.52V58.52H11.04V53.2Z" fill="black"/>
            <path d="M16.56 53.2H11.04V58.52H16.56V53.2Z" fill="black"/>
            <path d="M22.08 53.2H16.56V58.52H22.08V53.2Z" fill="black"/>
            <path d="M38.64 53.2H33.12L33.12 58.52H38.64V53.2Z" fill="black"/>
            <path d="M49.68 53.2H44.16V58.52H49.68V53.2Z" fill="black"/>
            <path d="M55.2 53.2H49.68V58.52H55.2V53.2Z" fill="black"/>
            <path d="M71.76 53.2H66.24V58.52H71.76V53.2Z" fill="black"/>
            <path d="M88.32 53.2H82.8L82.8 58.52H88.32V53.2Z" fill="black"/>
            <path d="M93.84 53.2H88.32V58.52H93.84V53.2Z" fill="black"/>
            <path d="M110.4 53.2H104.88V58.52H110.4V53.2Z" fill="black"/>
            <path d="M121.44 53.2H115.92V58.52H121.44V53.2Z" fill="black"/>
            <path d="M132.48 53.2H126.96V58.52H132.48V53.2Z" fill="black"/>
            <path d="M138 53.2H132.48V58.52H138V53.2Z" fill="black"/>
            <path d="M5.52 58.52H0V63.84H5.52V58.52Z" fill="black"/>
            <path d="M11.04 58.52H5.52V63.84H11.04V58.52Z" fill="black"/>
            <path d="M22.08 58.52H16.56V63.84H22.08V58.52Z" fill="black"/>
            <path d="M27.6 58.52H22.08V63.84H27.6V58.52Z" fill="black"/>
            <path d="M60.72 58.52H55.2V63.84H60.72V58.52Z" fill="black"/>
            <path d="M66.24 58.52H60.72V63.84H66.24V58.52Z" fill="black"/>
            <path d="M71.76 58.52H66.24V63.84H71.76V58.52Z" fill="black"/>
            <path d="M82.8 58.52H77.28V63.84H82.8L82.8 58.52Z" fill="black"/>
            <path d="M93.84 58.52H88.32V63.84H93.84V58.52Z" fill="black"/>
            <path d="M110.4 58.52H104.88V63.84H110.4V58.52Z" fill="black"/>
            <path d="M126.96 58.52H121.44V63.84H126.96V58.52Z" fill="black"/>
            <path d="M138 58.52H132.48V63.84H138V58.52Z" fill="black"/>
            <path d="M5.52 63.84H0V69.16H5.52V63.84Z" fill="black"/>
            <path d="M22.08 63.84H16.56V69.16H22.08V63.84Z" fill="black"/>
            <path d="M38.64 63.84H33.12V69.16H38.64V63.84Z" fill="black"/>
            <path d="M55.2 63.84H49.68V69.16H55.2V63.84Z" fill="black"/>
            <path d="M60.72 63.84H55.2V69.16H60.72V63.84Z" fill="black"/>
            <path d="M93.84 63.84H88.32V69.16H93.84V63.84Z" fill="black"/>
            <path d="M99.36 63.84H93.84V69.16H99.36V63.84Z" fill="black"/>
            <path d="M104.88 63.84H99.36V69.16H104.88V63.84Z" fill="black"/>
            <path d="M110.4 63.84H104.88V69.16H110.4V63.84Z" fill="black"/>
            <path d="M138 63.84H132.48V69.16H138V63.84Z" fill="black"/>
            <path d="M5.52 69.16H0V74.48H5.52V69.16Z" fill="black"/>
            <path d="M16.56 69.16H11.04V74.48H16.56V69.16Z" fill="black"/>
            <path d="M33.12 69.16H27.6V74.48H33.12L33.12 69.16Z" fill="black"/>
            <path d="M44.16 69.16H38.64V74.48H44.16V69.16Z" fill="black"/>
            <path d="M49.68 69.16H44.16V74.48H49.68V69.16Z" fill="black"/>
            <path d="M60.72 69.16H55.2V74.48H60.72V69.16Z" fill="black"/>
            <path d="M71.76 69.16H66.24V74.48H71.76V69.16Z" fill="black"/>
            <path d="M77.28 69.16H71.76V74.48H77.28V69.16Z" fill="black"/>
            <path d="M88.32 69.16H82.8V74.48H88.32V69.16Z" fill="black"/>
            <path d="M93.84 69.16H88.32V74.48H93.84V69.16Z" fill="black"/>
            <path d="M104.88 69.16H99.36V74.48H104.88V69.16Z" fill="black"/>
            <path d="M115.92 69.16H110.4V74.48H115.92V69.16Z" fill="black"/>
            <path d="M121.44 69.16H115.92V74.48H121.44V69.16Z" fill="black"/>
            <path d="M132.48 69.16H126.96V74.48H132.48V69.16Z" fill="black"/>
            <path d="M138 69.16H132.48V74.48H138V69.16Z" fill="black"/>
            <path d="M5.52 74.48H0V79.8H5.52V74.48Z" fill="black"/>
            <path d="M33.12 74.48H27.6V79.8H33.12V74.48Z" fill="black"/>
            <path d="M38.64 74.48H33.12V79.8H38.64V74.48Z" fill="black"/>
            <path d="M60.72 74.48H55.2V79.8H60.72V74.48Z" fill="black"/>
            <path d="M66.24 74.48H60.72V79.8H66.24V74.48Z" fill="black"/>
            <path d="M71.76 74.48H66.24V79.8H71.76V74.48Z" fill="black"/>
            <path d="M77.28 74.48H71.76V79.8H77.28V74.48Z" fill="black"/>
            <path d="M104.88 74.48H99.36V79.8H104.88V74.48Z" fill="black"/>
            <path d="M110.4 74.48H104.88V79.8H110.4V74.48Z" fill="black"/>
            <path d="M115.92 74.48H110.4V79.8H115.92V74.48Z" fill="black"/>
            <path d="M121.44 74.48H115.92V79.8H121.44V74.48Z" fill="black"/>
            <path d="M5.52 79.8H0V85.12H5.52V79.8Z" fill="black"/>
            <path d="M11.04 79.8L5.52 79.8V85.12H11.04V79.8Z" fill="black"/>
            <path d="M22.08 79.8H16.56V85.12H22.08V79.8Z" fill="black"/>
            <path d="M27.6 79.8L22.08 79.8V85.12H27.6V79.8Z" fill="black"/>
            <path d="M44.16 79.8L38.64 79.8V85.12H44.16V79.8Z" fill="black"/>
            <path d="M49.68 79.8H44.16V85.12H49.68V79.8Z" fill="black"/>
            <path d="M55.2 79.8L49.68 79.8V85.12H55.2V79.8Z" fill="black"/>
            <path d="M60.72 79.8H55.2V85.12H60.72V79.8Z" fill="black"/>
            <path d="M66.24 79.8H60.72V85.12H66.24V79.8Z" fill="black"/>
            <path d="M77.28 79.8H71.76V85.12H77.28V79.8Z" fill="black"/>
            <path d="M82.8 79.8L77.28 79.8V85.12H82.8V79.8Z" fill="black"/>
            <path d="M110.4 79.8H104.88V85.12H110.4V79.8Z" fill="black"/>
            <path d="M115.92 79.8H110.4V85.12H115.92V79.8Z" fill="black"/>
            <path d="M121.44 79.8H115.92V85.12H121.44V79.8Z" fill="black"/>
            <path d="M126.96 79.8L121.44 79.8V85.12H126.96V79.8Z" fill="black"/>
            <path d="M27.6 85.12H22.08V90.44H27.6V85.12Z" fill="black"/>
            <path d="M33.12 85.12H27.6V90.44H33.12V85.12Z" fill="black"/>
            <path d="M38.64 85.12H33.12V90.44H38.64V85.12Z" fill="black"/>
            <path d="M49.68 85.12H44.16V90.44H49.68V85.12Z" fill="black"/>
            <path d="M66.24 85.12H60.72V90.44H66.24V85.12Z" fill="black"/>
            <path d="M71.76 85.12H66.24V90.44H71.76V85.12Z" fill="black"/>
            <path d="M88.32 85.12H82.8L82.8 90.44H88.32V85.12Z" fill="black"/>
            <path d="M93.84 85.12H88.32V90.44H93.84V85.12Z" fill="black"/>
            <path d="M99.36 85.12H93.84V90.44H99.36V85.12Z" fill="black"/>
            <path d="M104.88 85.12H99.36V90.44H104.88V85.12Z" fill="black"/>
            <path d="M110.4 85.12H104.88V90.44H110.4V85.12Z" fill="black"/>
            <path d="M115.92 85.12H110.4V90.44H115.92V85.12Z" fill="black"/>
            <path d="M126.96 85.12H121.44V90.44H126.96V85.12Z" fill="black"/>
            <path d="M132.48 85.12H126.96V90.44H132.48V85.12Z" fill="black"/>
            <path d="M138 85.12H132.48V90.44H138V85.12Z" fill="black"/>
            <path d="M77.28 90.44H71.76V95.76H77.28V90.44Z" fill="black"/>
            <path d="M93.84 90.44H88.32V95.76H93.84V90.44Z" fill="black"/>
            <path d="M115.92 90.44H110.4V95.76H115.92V90.44Z" fill="black"/>
            <path d="M126.96 90.44H121.44V95.76H126.96V90.44Z" fill="black"/>
            <path d="M132.48 90.44H126.96V95.76H132.48V90.44Z" fill="black"/>
            <path d="M138 90.44H132.48V95.76H138V90.44Z" fill="black"/>
            <path d="M5.52 95.76H0V101.08H5.52V95.76Z" fill="black"/>
            <path d="M11.04 95.76H5.52V101.08H11.04V95.76Z" fill="black"/>
            <path d="M16.56 95.76H11.04V101.08H16.56V95.76Z" fill="black"/>
            <path d="M22.08 95.76H16.56V101.08H22.08V95.76Z" fill="black"/>
            <path d="M27.6 95.76H22.08V101.08H27.6V95.76Z" fill="black"/>
            <path d="M33.12 95.76H27.6V101.08H33.12V95.76Z" fill="black"/>
            <path d="M38.64 95.76H33.12V101.08H38.64V95.76Z" fill="black"/>
            <path d="M55.2 95.76H49.68V101.08H55.2V95.76Z" fill="black"/>
            <path d="M71.76 95.76H66.24V101.08H71.76V95.76Z" fill="black"/>
            <path d="M77.28 95.76H71.76V101.08H77.28V95.76Z" fill="black"/>
            <path d="M82.8 95.76H77.28V101.08H82.8V95.76Z" fill="black"/>
            <path d="M88.32 95.76H82.8V101.08H88.32V95.76Z" fill="black"/>
            <path d="M93.84 95.76H88.32V101.08H93.84V95.76Z" fill="black"/>
            <path d="M104.88 95.76H99.36V101.08H104.88V95.76Z" fill="black"/>
            <path d="M115.92 95.76H110.4V101.08H115.92V95.76Z" fill="black"/>
            <path d="M132.48 95.76H126.96V101.08H132.48V95.76Z" fill="black"/>
            <path d="M5.52 101.08H0V106.4H5.52V101.08Z" fill="black"/>
            <path d="M38.64 101.08H33.12L33.12 106.4H38.64V101.08Z" fill="black"/>
            <path d="M49.68 101.08H44.16V106.4H49.68V101.08Z" fill="black"/>
            <path d="M55.2 101.08H49.68V106.4H55.2V101.08Z" fill="black"/>
            <path d="M60.72 101.08H55.2V106.4H60.72V101.08Z" fill="black"/>
            <path d="M66.24 101.08H60.72V106.4H66.24V101.08Z" fill="black"/>
            <path d="M77.28 101.08H71.76V106.4H77.28V101.08Z" fill="black"/>
            <path d="M88.32 101.08H82.8L82.8 106.4H88.32V101.08Z" fill="black"/>
            <path d="M93.84 101.08H88.32V106.4H93.84V101.08Z" fill="black"/>
            <path d="M115.92 101.08H110.4V106.4H115.92V101.08Z" fill="black"/>
            <path d="M126.96 101.08H121.44V106.4H126.96V101.08Z" fill="black"/>
            <path d="M132.48 101.08H126.96V106.4H132.48V101.08Z" fill="black"/>
            <path d="M5.52 106.4H0V111.72H5.52V106.4Z" fill="black"/>
            <path d="M16.56 106.4H11.04V111.72H16.56V106.4Z" fill="black"/>
            <path d="M22.08 106.4H16.56V111.72H22.08V106.4Z" fill="black"/>
            <path d="M27.6 106.4H22.08V111.72H27.6V106.4Z" fill="black"/>
            <path d="M38.64 106.4H33.12V111.72H38.64V106.4Z" fill="black"/>
            <path d="M88.32 106.4H82.8V111.72H88.32V106.4Z" fill="black"/>
            <path d="M93.84 106.4H88.32V111.72H93.84V106.4Z" fill="black"/>
            <path d="M99.36 106.4H93.84V111.72H99.36V106.4Z" fill="black"/>
            <path d="M104.88 106.4H99.36V111.72H104.88V106.4Z" fill="black"/>
            <path d="M110.4 106.4H104.88V111.72H110.4V106.4Z" fill="black"/>
            <path d="M115.92 106.4H110.4V111.72H115.92V106.4Z" fill="black"/>
            <path d="M121.44 106.4H115.92V111.72H121.44V106.4Z" fill="black"/>
            <path d="M126.96 106.4H121.44V111.72H126.96V106.4Z" fill="black"/>
            <path d="M132.48 106.4H126.96V111.72H132.48V106.4Z" fill="black"/>
            <path d="M5.52 111.72H0V117.04H5.52V111.72Z" fill="black"/>
            <path d="M16.56 111.72H11.04V117.04H16.56V111.72Z" fill="black"/>
            <path d="M22.08 111.72H16.56V117.04H22.08V111.72Z" fill="black"/>
            <path d="M27.6 111.72H22.08V117.04H27.6V111.72Z" fill="black"/>
            <path d="M38.64 111.72H33.12V117.04H38.64V111.72Z" fill="black"/>
            <path d="M55.2 111.72H49.68V117.04H55.2V111.72Z" fill="black"/>
            <path d="M60.72 111.72H55.2V117.04H60.72V111.72Z" fill="black"/>
            <path d="M66.24 111.72H60.72V117.04H66.24V111.72Z" fill="black"/>
            <path d="M82.8 111.72H77.28V117.04H82.8L82.8 111.72Z" fill="black"/>
            <path d="M88.32 111.72H82.8L82.8 117.04H88.32V111.72Z" fill="black"/>
            <path d="M126.96 111.72H121.44V117.04H126.96V111.72Z" fill="black"/>
            <path d="M138 111.72H132.48V117.04H138V111.72Z" fill="black"/>
            <path d="M5.52 117.04H0V122.36H5.52V117.04Z" fill="black"/>
            <path d="M16.56 117.04H11.04V122.36H16.56V117.04Z" fill="black"/>
            <path d="M22.08 117.04H16.56V122.36H22.08V117.04Z" fill="black"/>
            <path d="M27.6 117.04H22.08V122.36H27.6V117.04Z" fill="black"/>
            <path d="M38.64 117.04H33.12V122.36H38.64V117.04Z" fill="black"/>
            <path d="M49.68 117.04H44.16V122.36H49.68V117.04Z" fill="black"/>
            <path d="M60.72 117.04H55.2V122.36H60.72V117.04Z" fill="black"/>
            <path d="M82.8 117.04H77.28V122.36H82.8V117.04Z" fill="black"/>
            <path d="M121.44 117.04H115.92V122.36H121.44V117.04Z" fill="black"/>
            <path d="M5.52 122.36H0V127.68H5.52V122.36Z" fill="black"/>
            <path d="M38.64 122.36H33.12V127.68H38.64V122.36Z" fill="black"/>
            <path d="M55.2 122.36H49.68V127.68H55.2V122.36Z" fill="black"/>
            <path d="M77.28 122.36H71.76V127.68H77.28V122.36Z" fill="black"/>
            <path d="M93.84 122.36H88.32V127.68H93.84V122.36Z" fill="black"/>
            <path d="M115.92 122.36H110.4V127.68H115.92V122.36Z" fill="black"/>
            <path d="M121.44 122.36H115.92V127.68H121.44V122.36Z" fill="black"/>
            <path d="M126.96 122.36H121.44V127.68H126.96V122.36Z" fill="black"/>
            <path d="M5.52 127.68H0V133H5.52V127.68Z" fill="black"/>
            <path d="M11.04 127.68H5.52V133H11.04V127.68Z" fill="black"/>
            <path d="M16.56 127.68H11.04V133H16.56V127.68Z" fill="black"/>
            <path d="M22.08 127.68H16.56V133H22.08V127.68Z" fill="black"/>
            <path d="M27.6 127.68H22.08V133H27.6V127.68Z" fill="black"/>
            <path d="M33.12 127.68H27.6V133H33.12L33.12 127.68Z" fill="black"/>
            <path d="M38.64 127.68H33.12L33.12 133H38.64V127.68Z" fill="black"/>
            <path d="M49.68 127.68H44.16V133H49.68V127.68Z" fill="black"/>
            <path d="M55.2 127.68H49.68V133H55.2V127.68Z" fill="black"/>
            <path d="M60.72 127.68H55.2V133H60.72V127.68Z" fill="black"/>
            <path d="M71.76 127.68H66.24V133H71.76V127.68Z" fill="black"/>
            <path d="M77.28 127.68H71.76V133H77.28V127.68Z" fill="black"/>
            <path d="M82.8 127.68H77.28V133H82.8V127.68Z" fill="black"/>
            <path d="M99.36 127.68H93.84V133H99.36V127.68Z" fill="black"/>
            <path d="M104.88 127.68H99.36V133H104.88V127.68Z" fill="black"/>
            <path d="M115.92 127.68H110.4V133H115.92V127.68Z" fill="black"/>
            <path d="M126.96 127.68H121.44V133H126.96V127.68Z" fill="black"/>
            <path d="M138 127.68H132.48V133H138V127.68Z" fill="black"/>
        </svg>
    )
}